"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const actionTypes = require("../../actionTypes/modelspace/project");
exports.initialState = {
    fetchStatus: 'STANDBY',
    searchStatus: 'STANDBY',
    saveStatus: 'STANDBY',
    configuration: null,
    searchResult: null
};
const featchStatusLens = monocle.Lens.fromProp('fetchStatus');
const searchStatusLens = monocle.Lens.fromProp('searchStatus');
const saveStatusLens = monocle.Lens.fromProp('saveStatus');
const configurationLens = monocle.Lens.fromProp('configuration');
const searchLens = monocle.Lens.fromProp('searchResult');
const methods = {};
exports.methods = methods;
// Fetch
methods[actionTypes.FETCH_REQUEST] = (state, action) => featchStatusLens.set('FETCHING')(state);
methods[actionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(configurationLens.set(action.payload), featchStatusLens.set('FETCHED'))(state);
methods[actionTypes.FETCH_FAILED] = (state, action) => featchStatusLens.set('FAILED')(state);
// Search
methods[actionTypes.SEARCH_REQUEST] = (state, action) => fp.function.compose(searchLens.set(null), searchStatusLens.set('FETCHING'))(state);
methods[actionTypes.SEARCH_SUCCESS] = (state, action) => fp.function.compose(searchLens.set(action.payload), searchStatusLens.set('FETCHED'))(state);
methods[actionTypes.SEARCH_FAILED] = (state, action) => searchStatusLens.set('FAILED')(state);
// Save
methods[actionTypes.SAVE_REQUEST] = (state, action) => saveStatusLens.set('FETCHING')(state);
methods[actionTypes.SAVE_SUCCESS] = (state, action) => saveStatusLens.set('FETCHED')(state);
methods[actionTypes.SAVE_FAILED] = (state, action) => saveStatusLens.set('FAILED')(state);
// Clear
methods[actionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=project.js.map